import { __cAuthService } from '@/services/client/__c.auth.service'
import { TConfirmInfoUserBody } from '@/types/auth'
import { useMutation } from '@tanstack/react-query'

export const useConfirmInfoUserMutation = () => {
  return useMutation({
    mutationKey: ['confirm-info-user'],
    mutationFn: async (body: TConfirmInfoUserBody) => {
      const response = await __cAuthService.confirmInfoUser(body)
      return response
    },
  })
}
